import type { MarketVariants } from '@/lib/i18n'

export type Slide8PracticeCopy = {
  /** Sender shown in the Messenger mockup. A photo avatar ties to this name. */
  senderName: string
  messageRequestLabel: string
  prefaceLabel: string
  messageBody: string
  acceptLabel: string
  deleteLabel: string

  question: string
  tapHint: string

  /** Each annotation quotes the phrase in `messageBody` that carries the flag,
   *  so the exercise still works when the message is translated. */
  flagSecrecyLabel: string
  flagSecrecyAnnotation: string
  flagTooGoodLabel: string
  flagTooGoodAnnotation: string
  flagPaymentLabel: string
  flagPaymentAnnotation: string
  flagStrangerLabel: string
  flagStrangerAnnotation: string
  flagAccessLabel: string
  flagAccessAnnotation: string

  checkLabel: string
  /** Reveal sentence: prefix + bold "{count}{revealOf5}" + suffix. */
  revealPrefix: string
  revealOf5: string
  revealSuffix: string
}

export const copy: MarketVariants<Slide8PracticeCopy> = {
  US: {
    senderName: 'Robert Chen',
    messageRequestLabel: 'Message request',
    prefaceLabel: 'Robert Chen wants to send you a message',
    messageBody:
      "I saw your comment on that gardening group and thought I'd reach out. I've been doing really well with a new investment platform. Guaranteed 12% monthly returns. They're only accepting new members this week though, so you'd need to sign up today. You can transfer funds by bank transfer or crypto. Just send me your details and I'll set you up. I'd keep it between us for now, let the results speak for themselves!",
    acceptLabel: 'Accept',
    deleteLabel: 'Delete',

    question: 'How many red flags can you spot?',
    tapHint: 'Tap each one you can find',

    flagSecrecyLabel: 'Demands for secrecy',
    flagSecrecyAnnotation: '“Keep it between us for now”',
    flagTooGoodLabel: 'Too good to be true',
    flagTooGoodAnnotation: '“Guaranteed 12% monthly returns”',
    flagPaymentLabel: 'Untraceable payment method',
    flagPaymentAnnotation: '“Bank transfer or crypto”',
    flagStrangerLabel:
      "Payment request from someone you haven't met in person",
    flagStrangerAnnotation: 'A stranger who found you on social media',
    flagAccessLabel: 'Requests for your personal details',
    flagAccessAnnotation: "“Send me your details and I'll set you up”",

    checkLabel: 'Check my answers',
    revealPrefix: 'All five red flags in a single message. You spotted ',
    revealOf5: ' out of 5',
    revealSuffix: '.',
  },
  // Qatar face: nothing to localize. The sender keeps his name because the
  // avatar photo ties to it, and the message itself (WhatsApp-style investment
  // pitch, bank transfer or crypto) is already the locally recognizable shape.
  ar: {
    senderName: 'روبرت تشين',
    messageRequestLabel: 'طلب مراسلة',
    prefaceLabel: 'روبرت تشين يريد إرسال رسالة إليك',
    messageBody:
      'رأيت تعليقك في مجموعة البستنة وفكّرت أن أتواصل معك. أحقق نتائج ممتازة مع منصة استثمار جديدة. عوائد شهرية مضمونة بنسبة 12%. لكنهم يقبلون أعضاء جدداً هذا الأسبوع فقط، لذا عليك التسجيل اليوم. يمكنك إيداع الأموال بتحويل مصرفي أو بالعملات الرقمية. فقط أرسل لي بياناتك وسأتولى تسجيلك. أفضّل أن يبقى الأمر بيننا في الوقت الحالي، ودع النتائج تتحدث عن نفسها!',
    acceptLabel: 'قبول',
    deleteLabel: 'حذف',

    question: 'كم إشارة خطر يمكنك رصدها؟',
    tapHint: 'اضغط على كل إشارة تجدها',

    flagSecrecyLabel: 'المطالبة بالسرية',
    flagSecrecyAnnotation: '"أفضّل أن يبقى الأمر بيننا في الوقت الحالي"',
    flagTooGoodLabel: 'أفضل من أن يكون حقيقياً',
    flagTooGoodAnnotation: '"عوائد شهرية مضمونة بنسبة 12%"',
    flagPaymentLabel: 'طريقة دفع لا يمكن تتبّعها',
    flagPaymentAnnotation: '"بتحويل مصرفي أو بالعملات الرقمية"',
    flagStrangerLabel: 'طلب دفع من شخص لم تقابله شخصياً',
    flagStrangerAnnotation: 'شخص غريب عثر عليك عبر وسائل التواصل الاجتماعي',
    flagAccessLabel: 'طلب بياناتك الشخصية',
    flagAccessAnnotation: '"أرسل لي بياناتك وسأتولى تسجيلك"',

    checkLabel: 'تحقّق من إجاباتي',
    revealPrefix: 'إشارات الخطر الخمس كلها في رسالة واحدة. لقد رصدت ',
    revealOf5: ' من أصل 5',
    revealSuffix: '.',
  },
}
